import React, { Component } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

import { Card, CardBody, Col, Container, Row} from "reactstrap"
import { Link } from "react-router-dom"
import { BaseUrl } from "../../../helpers/Baseurl"

//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';


class TermsConditions extends Component {
  constructor(props) {
    super(props)
    this.state = {
        signature_id:"",
        alert_confirm : false,
        success_confirm : false,
        dynamic_title: "",
        dynamic_description: "",

        signatures: [],
        breadcrumbItems : [
            { title : "Planmans", link : "/dashboard" },
            { title : "Terms & Conditions", link : "#" },
        ],
    }

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
      }

  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    this.props.history.push('/dashboard')
    toastr.error("Something Went Wrong", "")
  }

  async componentDidMount() {
    document.title = "Terms & Conditions | Planmans"
    this.loadData();
 }

 async loadData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  await fetch(`${BaseUrl}/api/cms/categories/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              this.setState({ signatures: data  })
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }


  render() {

    const { signatures } = this.state

    //Columns
    const signaturesColumns = [
      {
        dataField: "id",
        text: "id",
        hidden: true,
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
        headerStyle: { backgroundColor: '#fcb92c' },
        formatter: (cellContent, row) => (
          <React.Fragment>
            <Link to="#" onClick={() => this.props.history.push(`/terms-and-conditions-detail/${row.id}/${row.name}`) } className="me-3 text-dark">{row.name}</Link>

            </React.Fragment>
        ),
      },
    ]

    return (
      <React.Fragment>
        <div className="page-content">
          
          <Container fluid>
          <Breadcrumbs title="Terms & Conditions" breadcrumbItems={this.state.breadcrumbItems} />
            <Row>
              <Col xs="6">
                <Card>
                  <CardBody>
                    <BootstrapTable
                        keyField="id"
                        data={signatures}
                        columns={signaturesColumns}
                      />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default TermsConditions